import React, {Component, Fragment} from 'react'
import {
  ControlBar,
  CurrentTimeDisplay,
  ForwardControl,
  PlaybackRateMenuButton,
  Player,
  ReplayControl,
  TimeDivider,
} from 'video-react'

class Video extends Component {
  render() {
    const {fileLinkList} = this.props
    const content = fileLinkList.map(fileLink => (
      <div style={{paddingTop: '20px'}}>
        <Player>
          <source src={fileLink} />
          <ControlBar>
            <ReplayControl seconds={10} order={1.1} />
            <ForwardControl seconds={30} order={1.2} />
            <CurrentTimeDisplay order={4.1} />
            <TimeDivider order={4.2} />
            <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
          </ControlBar>
        </Player>
      </div>
    ))
    return <Fragment>{content}</Fragment>
  }
}

export default Video
